const initialState = {
  values: []  
}

export const register = (state = initialState, action) => {
  switch (action.type) {
    case "SIGNUP_WITH_EMAIL": {
      return { ...state, values: action.payload }
    }    
    default: {
      return state
    }
  }
}
